import { XMarkIcon } from '@heroicons/react/16/solid';
import { Button, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useTeamContext } from '../../../Team.context.ts';
import DeleteUserForm from './DeleteUser.form.tsx';

export default function DeleteUserModal() {
  const { t } = useTranslation('settings/team');
  const { toggleDeleteModal, showDeleteModal, userToDelete } = useTeamContext();

  return (
    <Modal open={showDeleteModal} className="DeleteUserModal">
      <Modal.Header className="DeleteUserModal__Header">
        <Button
          color="ghost"
          size="sm"
          shape="square"
          onClick={() => toggleDeleteModal(false)}
        >
          <XMarkIcon className="DeleteUserModal__CloseIcon" />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="DeleteUserModal__Name">
          <p className="text-4xl">⚠️</p>
          <p className="text-lg">
            {t('page.form.label.modal-delete-user.text')}
          </p>
          <p className="DeleteUserModal__Name__Text">{userToDelete?.name}</p>
        </div>
        <DeleteUserForm />
      </Modal.Body>
    </Modal>
  );
}
